import { api } from "../../services/NetworkBase";

export async function GetSystemConfigurations() {
  try {
    let response = await api
      .get(`vlp/general-maintenance/system-configurations`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateEmailBody(emailType, emailBody) {
  try {
    let response = await api.put(
      "vlp/general-maintenance/system-configurations/email-body/" + emailType,
      { json: emailBody }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateSystemConfigurations(systemConfigurations) {
  try {
    let response = await api.put(
      "vlp/general-maintenance/system-configurations",
      { json: systemConfigurations }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetChemicals() {
  try {
    let response = await api.get(`vlp/general-maintenance/chemicals`).json();
    return response;
  } catch (error) {
    throw error;
  }
}
//SaveChemical
export async function UpdateChemical(chem) {
  try {
    let response = await api.put("vlp/general-maintenance/chemicals", {
      json: chem,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveChemical(chem) {
  try {
    let response = await api.post("vlp/general-maintenance/chemicals", {
      json: chem,
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export async function UpdateEquipment(equipment) {
  try {
    let response = await api.put("vlp/general-maintenance/equipments", {
      json: equipment,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveEquipment(equipment) {
  try {
    let response = await api.post("vlp/general-maintenance/equipments", {
      json: equipment,
    });
    return response;
  } catch (error) {
    throw error;
  }
}



export async function GetEquipments() {
  try {
    let response = await api.get(`vlp/general-maintenance/equipments`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetAvailableThermometers(excludeItemId) {
  try {
    let response = await api
      .get(`vlp/general-maintenance/equipments/available-thermometers`, {
        searchParams: { excludeItemId: excludeItemId || 0 },
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteEquipment(id) {
  try {
    let response = await api
      .delete(`vlp/general-maintenance/equipments/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
export async function GetVendors() {
  try {
    let response = await api.get(`vlp/general-maintenance/vendors`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

//SaveVendor, UpdateVendor

export async function UpdateVendor(vendor) {
  try {
    let response = await api.put("vlp/general-maintenance/vendors", {
      json: vendor,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveVendor(vendor) {
  try {
    let response = await api.post("vlp/general-maintenance/vendors", {
      json: vendor,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

//DeleteVendor

export async function DeleteVendor(id) {
  try {
    let response = await api
      .delete(`vlp/general-maintenance/vendors/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteChemical(id) {
  try {
    let response = await api
      .delete(`vlp/general-maintenance/chemicals/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
